export const SAVINGS_PLAN_MODAL_CONTINUE_BUTTON_TEST_ID = "savings-plan-modal-continue-button";
